import { render } from "./WorkspaceComponent.vue?vue&type=template&id=3854b42a&scoped=true"
import script from "./WorkspaceComponent.vue?vue&type=script&lang=js"
export * from "./WorkspaceComponent.vue?vue&type=script&lang=js"

import "./WorkspaceComponent.vue?vue&type=style&index=0&id=3854b42a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3854b42a"]])

export default __exports__